import { useEffect, useState, useRef } from 'react';

export default function useAriaLiveMatchCount() {
  const [message, setMessage] = useState('');
  const liveRegionRef = useRef(null);

  const updateMatchCount = (count) => {
    setMessage(`${count} match${count === 1 ? '' : 'es'} found, press Tab key to navigate to the results.`);
  };

  useEffect(() => {
    if (liveRegionRef.current && message) {
      liveRegionRef.current.textContent = message;
    }
  }, [message]);

  const LiveRegion = () => (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{ position: 'absolute', left: '-9999px' }}
      ref={liveRegionRef}
    />
  );

  return { updateMatchCount, LiveRegion };
}
